export const MODAL_LIST_DATA = {
  ACCOUNT_CONFIRM_EMAIL: 'ACCOUNT_CONFIRM_EMAIL',
  ACCOUNT_DELETE: 'ACCOUNT_DELETE',
  ACCOUNT_DOWNLOAD_DATA: 'ACCOUNT_DOWNLOAD_DATA',
  CAR_BREAKDOWN: 'CAR_BREAKDOWN',
  CREDIT_RATING: 'CREDIT_RATING',
  DIGITAL_CHANNELS: 'DIGITAL_CHANNELS',
  HOME_BREAKDOWN: 'HOME_BREAKDOWN',
  NETWORK_AVAILABILITY: 'NETWORK_AVAILABILITY',
  NEWSLETTER_FAILURE: 'NEWSLETTER_FAILURE',
  NEWSLETTER_SIGNUP: 'NEWSLETTER_SIGNUP',
  NEWSLETTER_SUCCESS: 'NEWSLETTER_SUCCESS',
  QUOTE_PENDING: 'QUOTE_PENDING',
  VIDEO: 'VIDEO'
};
